import _ from 'lodash'
import { ActionTypes } from '@app/constants'
import { Student } from '@app/models/users'
import Card from '@app/models/card'

const processStatistics = (action) => {
  return _
    .chain(action.statistics)
    .map((result) => {
      _.each(result.tours, (tour) => {
        _.update(tour, 'student', (object) => new Student(object))
        _.each(tour.tasks, (object) => {
          _.update(object, 'task', (task) => new Card(task))
        })
      })

      return result
    })
    .sortBy('student.fullName')
    .value()
}

const statistics = (state = {
  object: null,
  fetching: false,
  error: null,
  updatedOn: null,
  didInvalidate: false
}, action) => {
  switch(action.type) {
  case ActionTypes.CHILDREN_STATISTICS_REQUEST:
    return { ...state, fetching: true, error: null }

  case ActionTypes.CHILDREN_STATISTICS_RECEIVING_SUCCESS:
    return {
      ...state,
      fetching: false,
      updatedOn: action.updatedOn,
      object: processStatistics(action),
      didInvalidate: false
    }

  case ActionTypes.CHILDREN_STATISTICS_RECEIVING_FAILURE:
    return {
      ...state,
      fetching: false,
      error: action.error,
      didInvalidate: true
    }

  default:
    return state
  }
}

export default statistics
